/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GeoJsonRealAssetTracklineConfig = {
    type: GeoJsonRealAssetTracklineConfig.type;
    /**
     *
     * Regular expression pattern to locate GeoJSON files containing trackline data.
     *
     * The GeoJSON must contain:
     * - LineString features with coordinates
     * - coordTimes property with timestamps for each coordinate
     *
     */
    pattern: string;
};

export namespace GeoJsonRealAssetTracklineConfig {

    export enum type {
        GEOJSON = 'geojson',
    }


}

